import { getHttpClient } from 'src/http-client';

export async function getBoardColumnService(args: {
  projectId: string;
  organizationName: string
}) {
	try {
		const client = getHttpClient();
		const response = await client.get(`https://dev.azure.com/${args.organizationName}/${args.projectId}/_apis/work/boardcolumns?api-version=7.1-preview.1`);

		if (response.status === 200) {
			return response.data;
		}

		return null;
	} catch (err) {
		throw new Error('Get board column field error.');
	}
}